import React from "react";
import Header from "../Components/Header";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import "./Cart.css";
import cartImg from "../assets/images/cartImg.png";
import paymentIcons from "../assets/images/paymentIcons.png";
import { Link } from "react-router-dom"; //Link
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function Checkout() {
  return (
    <div>
      <Header mode="dark" />

      <div className="checkout-page">
        <div className="container-fluid">
          <div className="breadcrumb_title detail_page_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="/products">Shop</Breadcrumb.Item>
              <Breadcrumb.Item active>Checkout</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div className="row">
            {/* LEFT FORM */}
            <div className="col-md-7">
              <div className="checkout_inforamtion">
                  <h5 className="section-title">Information</h5>

              <form className="row g-3">
                <div class="col-md-12">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Country / Region"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="First Name"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
                <div class="col-md-12">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Company (optional)"
                  />
                </div>
                <div class="col-md-12">
                  <textarea
                    class="form-control"
                    placeholder="Address"
                    rows="3"
                  ></textarea>
                </div>
                <div class="col-md-12">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Apartment, suite etc (optional)"
                  />
                </div>
                <div class="col-md-4">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="City"
                  />
                </div>
                <div class="col-md-4">
                  <select
                    class="form-select"
                    aria-label="Default select example"
                  >
                    <option selected>State</option>
                    <option value="Jaipur">Jaipur</option>
                    <option value="Jodhpur">Jodhpur </option>
                    <option value="Udaipur ">Udaipur </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Pincode"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Phone Number"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Email Address"
                  />
                </div>
              </form>

              <div className="billing_adrs">
                <h5 className="section-title">Billing Address</h5>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultChecked
                  />
                  <label className="form-check-label">
                    Same as shipping address
                  </label>
                </div>

                <div className="form-check">
                  <input className="form-check-input" type="checkbox" />
                  <label className="form-check-label">
                    Use a different billing address
                  </label>
                </div>
              </div>
              </div>
              
            </div>

            {/* RIGHT SUMMARY */}
          
            <div className="col-md-5  ">
                <div className="summary-section p-4">
              {/* Product */}
              <div className="product d-flex">
                <img src={cartImg} alt="" className="img-fluid" />
                <div className="ms-3 flex-grow-1">
                  <h6>NAZAKAT HAND WOVEN BEIGE COTTON CUSHION COVER</h6>
                  <small>Size: 46x46 cm</small>
                  <small>Qty: 1</small>
                </div>
                <div className="check_price">₹ 3,000.00</div>
              </div>

              <div className="product d-flex">
                <img src={cartImg} alt="" className="img-fluid" />
                <div className="ms-3 flex-grow-1">
                  <h6>NAZAKAT HAND WOVEN BEIGE COTTON CUSHION COVER</h6>
                  <small>Size: 46x46 cm</small>
                  <small>Qty: 1</small>
                </div>
                <div className="check_price">₹ 3,000.00</div>
              </div>

              {/* Discount */}
              <div className="d-flex discount_input">
                <input
                  className="form-control"
                  placeholder="Discount Code or Gift Card"
                />
                <button className="btn btn-dark">Apply</button>
              </div>

              {/* Price */}
              <div className="price-row">
                <span>Subtotal</span>
                <span>₹ 6,000.00</span>
              </div>

              <div className="price-row">
                <span>Tax</span>
                <span>₹ 800.00</span>
              </div>

              <div className="price-row">
                <span>Shipping</span>
                <span className="text-muted">Enter Shipping Address</span>
              </div>

              <hr />

              <div className="total-row">
                <span>Total</span>
                <span>₹ 6,800.00</span>
              </div>

              {/* Payment */}
              <div className="payment-box mt-4 p-3">
                <h5>Payment</h5>
                <p className="small">
                  <LockOutlinedIcon /> All transactions are secure and
                  encrypted.
                </p>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="payment"
                    defaultChecked
                  />
                  <label className="form-check-label">
                    Online
                    <img src={paymentIcons} alt="" className="img-fluid" />
                  </label>
                </div>

                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="payment"
                  />
                  <label className="form-check-label">Cash on Delivery</label>
                </div>
              </div>

              <button className="btn btn-dark w-100 mt-4 pay-btn">
                <Link to="/thankyou">
                Pay Now
                </Link>
              </button>
            </div>
            </div>

          </div>
        </div>
      </div>

      <Feature />
      <Footer />
    </div>
  );
}
